import styled from "styled-components";
import { primaryColor, topBarHeight } from "../../../../config/constants";

export const SelectorBar = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: 100%;
  height: ${topBarHeight};
  background-color: #fff;
`;
// Mismo ancho que el contenido, para que el boton quede alineado con el borde
// derecho de las tarjetas y no con el del navegador.
export const SelectorInner = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
  max-width: 900px;
`;
export const SelectorButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px;
  border: none;
  font-size: 14px;
  color: #555;
  background: none;
  outline: none;
  cursor: pointer;
`;
export const Flag = styled.img`
  width: 22px;
  height: 16px;
  object-fit: contain;
`;
export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
`;
export const Modal = styled.div`
  padding: 32px;
  width: 100%;
  max-width: 352px;
  max-height: 80vh;
  overflow-y: auto;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.2);
`;
export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;
export const ModalTitle = styled.h3`
  font-size: 18px;
  color: #333;
`;
export const CloseButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  outline: none;
  cursor: pointer;
`;
export const CloseIcon = styled.img`
  width: 24px;
  height: 24px;
`;
export const LanguageOption = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
  padding: 10px 12px;
  width: 100%;
  border: 1px solid ${({ $isSelected }) => ($isSelected ? primaryColor : "transparent")};
  border-radius: 6px;
  font-size: 14px;
  color: #333;
  text-align: left;
  background-color: ${({ $isSelected }) => ($isSelected ? "#fff" : "#fafafa")};
  outline: none;
  cursor: pointer;
`;
export const RadioIcon = styled.img`
  flex-shrink: 0;
  width: 18px;
  height: 18px;
`;
